module.exports = __webpack_public_path__ + "img/index1.610cc50d.png";